import React from 'react';
import usePrice from 'src/hooks/usePrice';
import { formatFittingTime } from 'helpers/utilities';
import Wrench from 'src/assets/icons/wrench.svg';
import Button from 'components/Button/Button';
import Label from 'components/_utility/Label';
import { getPackTotal, getPackFittingTotal } from 'helpers/packs';
import cloudinary from 'helpers/cloudinary';
import { Wrap, Image, Content, Name, TotalWrap, Price, Fitting, Tag } from './PackCard.styled';

const PackCard = ({ onSelectCard, ...pack }) => {
  const formatPrice = usePrice();

  return (
    <Wrap>
      <Image bgImage={encodeURI(cloudinary(pack?.thumbnail?.src, 'c_thumb,w_400'))}>
        {pack.tagText ? (
          <Tag
            dangerouslySetInnerHTML={{
              __html: pack.tagText,
            }}
          />
        ) : null}
      </Image>
      <Content>
        <Name>{pack.name}</Name>
        <TotalWrap>
          <Price>{formatPrice(getPackTotal(pack))}</Price>
          <Wrench />
          <Fitting>{formatFittingTime(getPackFittingTotal(pack))}</Fitting>
        </TotalWrap>
        <Button onClick={() => onSelectCard(pack.id)} primary small fluid data-testid={pack.id}>
          <Label name="viewPackLabel" />
        </Button>
      </Content>
    </Wrap>
  );
};

export default PackCard;
